var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18183_403737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6398 32.6251C25.5987 32.6251 33.2357 21.3702 33.2357 11.6129C33.2357 11.2965 33.2285 10.9731 33.214 10.6567C34.6996 9.61131 35.9817 8.3165 37 6.83307C35.6164 7.43202 34.1474 7.82319 32.6431 7.99323C34.227 7.06948 35.4129 5.61833 35.9811 3.90877C34.491 4.76796 32.8615 5.37404 31.1624 5.70104C30.0175 4.51746 28.5039 3.7338 26.8553 3.4712C25.2068 3.2086 23.5153 3.4817 22.0424 4.24827C20.5694 5.01484 19.3969 6.23218 18.7063 7.71209C18.0158 9.192 17.8455 10.852 18.2218 12.4356C15.2047 12.2883 12.2531 11.5257 9.5583 10.1973C6.86354 8.86886 4.48578 7.00428 2.57916 4.7244C1.61012 6.34999 1.31359 8.27359 1.74984 10.1043C2.18609 11.9349 3.32239 13.5353 4.92779 14.5801C3.72255 14.5429 2.54371 14.2271 1.48867 13.659V13.7504C1.48759 15.4563 2.09373 17.11 3.20406 18.4303C4.31439 19.7506 5.86037 20.656 7.57922 20.9926C6.46275 21.2898 5.29097 21.3331 4.15455 21.1192C4.63958 22.5863 5.58326 23.8695 6.8539 24.7896C8.12453 25.7098 9.65873 26.221 11.2424 26.252C8.55382 28.3068 5.23269 29.4213 1.81387 29.416C1.20757 29.4151 0.601865 29.379 0 29.3078C3.47315 31.4757 7.51336 32.6272 11.6398 32.6251Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18183_403737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.0a48690c.svg";
export { ForwardRef as ReactComponent };